import React, { Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import actions from 'actions';
import { toast } from 'react-toastify';
import moment from 'moment';
import axios from 'axios'
import constants from 'constants'

const {
  joinWebinarFromQRSaga,
  loadWebinarSaga
} = actions;

const {
  ERROR_TYPE_REQUEST
} = constants

class JoinQRCodeWebinar extends Component {
  constructor(props) {
    super(props)
  }

  componentWillMount = () => {
    if(!this.props.user.id) this.props.router.push(`/users/sign_in?redirectBack=${this.props.location.pathname}`)
    this.props.getWebinar(this.props.params.id)
  }

  joinWebinar = () => {
    console.log('LOL: ', this.props.params.id)
    this.props.joinWebinar(this.props.params.id)
  }

  render() {
    const { props: { webinar, errors }, joinWebinar } = this
    console.log(errors)
    return errors ? (
      <main className='join_qr'>
        <p>{errors.data.error_messages}</p>
      </main>
    ) : (
      <main className='join_qr'>
          <p>Please confirm your attendance at this meeting</p>
          <h4>{webinar.webinar_title}</h4>
          <span>{moment().format('DD/MM/YYYY')}</span>
          <a className='button_classic' onClick={joinWebinar}>Tap to confirm attendance</a>
      </main>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.users.user,
    webinar: state.webinars.tmp,
    errors: state.errors[ERROR_TYPE_REQUEST]
  };
}

function mapDispatchToProps(dispatch) {
  return {
    joinWebinar: (id) => dispatch(joinWebinarFromQRSaga(id)),
    getWebinar: (id) => dispatch(loadWebinarSaga(id, true, false, false, true))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(JoinQRCodeWebinar);



// WEBPACK FOOTER //
// ./src/containers/JoinQRCodeWebinar/index.jsx